	
<div id="services" class="offerings-container notes-content">

		<div *ngIf="notesFocus.image" class="notes-banner">
			<img src="{{notesFocus.image}}" /> 
		</div>		

			
		<div class="title-container">
			
					<div *ngIf="notesFocus.title" class="highlight offerings-title">

						{{notesFocus.title}}
					</div>
			

		</div>
			
		<div *ngIf="notesFocus.date" class="notes-date">{{notesFocus.date}}</div>
		<div *ngIf="notesFocus.context" class="notes-context">{{notesFocus.context}}</div>
		<div *ngIf="notesFocus.body" class="notes-body">

		<div *ngFor="let item of notesFocus.body" class="paragraph-container" >

			<img *ngIf="item.image" src="{{item.image}}" class="notes_img" [ngClass]="{'right' : item.image_position && item.image_position == 'right', 'left' : item.image_position && item.image_position == 'left'}"/>
			
			<p [innerHTML]="formatTextArray(item.text, item.image_position, item.image)" [ngClass]="{'right' : item.image_position && item.image_position != 'right', 'left' : item.image_position && item.image_position != 'left'}">
				
			</p>
			
		</div>
	</div>

</div>


